import { ChangeDetectionStrategy, Component } from "@angular/core";
import { animate, style, transition, trigger } from "@angular/animations";
import { MatIconModule, MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { NotifyConfigModel } from "src/app/_models/notify-config.model";
import { SnackbarService } from "src/app/_services/snackbar.service";
import { AddPunctuationPipe } from "src/app/_pipes/add-punctuation.pipe";
import { AsyncPipe, NgIf } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";

@Component({
    selector: "dello-notify",
    templateUrl: "./notify.component.html",
    styleUrls: ["./notify.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [AsyncPipe, NgIf, MatIconModule, MatButtonModule, AddPunctuationPipe],
    animations: [
        trigger("notifyItem", [
            transition(":enter", [
                style({ transform: "translateY(100%)", opacity: 0 }),
                animate("250ms ease-out", style({ transform: "translateY(0)", opacity: 1 })),
            ]),
            transition(":leave", [animate("150ms ease-in", style({ transform: "translateY(100%)", opacity: 0 }))]),
        ]),
    ],
})
export class NotifyComponent {
    readonly displayedMessages$ = this.snackBarService.notificationsSubject;

    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
        private snackBarService: SnackbarService,
    ) {
        this.matIconRegistry.addSvgIcon(
            "simple_error_hint",
            this.domSanitizer.bypassSecurityTrustResourceUrl("assets/svg/simple_error_hint.svg"),
        );
        this.matIconRegistry.addSvgIcon(
            "simple_warning_hint",
            this.domSanitizer.bypassSecurityTrustResourceUrl("assets/svg/simple_warning_hint.svg"),
        );
        this.matIconRegistry.addSvgIcon(
            "simple_success_hint",
            this.domSanitizer.bypassSecurityTrustResourceUrl("assets/svg/simple_success_hint.svg"),
        );
    }

    onClose(index: number): void {
        this.snackBarService.onClose(index);
    }

    onAction(item: NotifyConfigModel): void {
        this.snackBarService.onAction(item);
    }
}
